import { useState, useEffect, useRef } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendar } from "primereact/calendar";
import {
  getCreditsGroupedByType,
  approveCreditService,
  disburseCreditService,
  getFullInformationCreditService,
  payCredit,
  declineCredit,
} from "../services/adminCredit.Service";
import { ApproveCreditDto } from "../models/approve-credit.models";

const styles = `
  .ca-root {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .ca-root * {
    box-sizing: border-box;
  }

  .ca-root .p-accordion .p-accordion-header .p-accordion-header-link {
    background: #ffffff !important;
    border: 1px solid #e8eaed !important;
    border-radius: 12px !important;
    padding: 16px 18px !important;
    color: #1a1d23 !important;
    box-shadow: none !important;
  }
  .ca-root .p-accordion .p-accordion-header:not(.p-highlight):not(.p-disabled):hover .p-accordion-header-link {
    background: #fafbfc !important;
    border-color: #d1d5db !important;
  }
  .ca-root .p-accordion .p-accordion-header.p-highlight .p-accordion-header-link {
    background: #ffffff !important;
    border-color: #00A86B !important;
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .ca-root .p-accordion .p-accordion-content {
    background: #ffffff !important;
    border: 1px solid #00A86B !important;
    border-top: none !important;
    border-radius: 0 0 12px 12px !important;
    padding: 14px 18px 18px !important;
    overflow: hidden !important;
  }
  .ca-root .p-accordion .p-accordion-tab {
    margin-bottom: 10px;
    overflow: hidden;
    border-radius: 12px;
  }
  .ca-root .p-accordion-header-link .p-icon,
  .ca-root .p-accordion-toggle-icon {
    color: #6b7280 !important;
  }

  .ca-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: 10px;
  }
  .ca-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
  }
  .ca-header-icon {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    background: #f0fdf8;
    color: #00A86B;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    flex-shrink: 0;
  }
  .ca-header-title {
    font-weight: 700;
    font-size: 0.9rem;
    color: #1a1d23;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ca-header-sub {
    font-size: 0.72rem;
    color: #9ca3af;
    margin-top: 1px;
  }
  .ca-header-count {
    background: #f4f6f9;
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 0.7rem;
    font-weight: 600;
    color: #6b7280;
    white-space: nowrap;
    flex-shrink: 0;
  }

  .ca-table.p-datatable .p-datatable-thead > tr > th {
    background: #f8fafc !important;
    color: #374151 !important;
    font-size: 0.66rem !important;
    font-weight: 700 !important;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    border: none !important;
    padding: 10px 12px !important;
  }
  .ca-table.p-datatable .p-datatable-tbody > tr {
    background: #ffffff !important;
    color: #374151 !important;
  }
  .ca-table.p-datatable .p-datatable-tbody > tr.p-highlight,
  .ca-table.p-datatable .p-datatable-tbody > tr:focus,
  .ca-table.p-datatable .p-datatable-tbody > tr.p-row-odd {
    background: #ffffff !important;
    color: #374151 !important;
  }
  .ca-table.p-datatable .p-datatable-tbody > tr > td {
    font-size: 0.78rem !important;
    color: #374151 !important;
    padding: 10px 12px !important;
    border-bottom: 1px solid #f1f3f5 !important;
    vertical-align: middle !important;
    background: transparent !important;
  }
  .ca-table.p-datatable .p-datatable-tbody > tr:hover {
    background: #fafffd !important;
  }
  .ca-table.p-datatable .p-datatable-tbody > tr:hover > td {
    background: transparent !important;
  }
  .ca-table .p-datatable-wrapper {
    border-radius: 10px;
    border: 1px solid #f1f3f5;
    overflow: hidden;
  }
  .ca-table .p-datatable-emptymessage td {
    text-align: center !important;
    padding: 22px 0 !important;
    color: #9ca3af !important;
    font-style: italic;
    font-size: 0.8rem !important;
  }

  .ca-cell-title {
    font-weight: 700;
    font-size: 0.8rem;
    color: #1a1d23;
  }
  .ca-cell-sub {
    font-size: 0.68rem;
    color: #9ca3af;
    margin-top: 2px;
  }

  .ca-amount-label {
    font-size: 0.6rem;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 600;
  }
  .ca-amount-value {
    font-size: 0.84rem;
    font-weight: 700;
    color: #1a1d23;
  }

  .ca-pill {
    font-size: 0.68rem;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 20px;
    white-space: nowrap;
    display: inline-block;
  }
  .ca-pill.warning { background: #fffbeb; color: #b45309; }
  .ca-pill.info    { background: #eff6ff; color: #1d4ed8; }
  .ca-pill.success { background: #f0fdf8; color: #047857; }
  .ca-pill.danger  { background: #fef2f2; color: #b91c1c; }

  .ca-mora {
    font-size: 0.68rem;
    font-weight: 700;
    color: #b91c1c;
    background: #fef2f2;
    border-radius: 6px;
    padding: 2px 8px;
    white-space: nowrap;
  }

  .ca-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    flex-wrap: nowrap;
  }
  .ca-btn-approve.p-button {
    background: #ffffff !important;
    border: 1px solid #3b82f6 !important;
    color: #1d4ed8 !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    padding: 6px 12px !important;
    box-shadow: none !important;
    white-space: nowrap;
  }
  .ca-btn-approve.p-button:enabled:hover {
    background: #eff6ff !important;
  }
  .ca-btn-approve.p-button:disabled {
    opacity: 0.35 !important;
  }

  .ca-btn-disburse.p-button {
    background: #00A86B !important;
    border: none !important;
    color: #fff !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    padding: 6px 12px !important;
    box-shadow: none !important;
    white-space: nowrap;
  }
  .ca-btn-disburse.p-button:enabled:hover {
    background: #009960 !important;
  }
  .ca-btn-disburse.p-button:disabled {
    opacity: 0.35 !important;
  }

  .ca-btn-view.p-button {
    background: #ffffff !important;
    border: 1px solid #d1d5db !important;
    color: #374151 !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    padding: 6px 12px !important;
    box-shadow: none !important;
    white-space: nowrap;
  }
  .ca-btn-view.p-button:enabled:hover {
    background: #f8fafc !important;
  }

  .ca-btn-pay.p-button {
    background: #ffffff !important;
    border: 1px solid #00A86B !important;
    color: #047857 !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    padding: 6px 12px !important;
    box-shadow: none !important;
    white-space: nowrap;
  }
  .ca-btn-pay.p-button:enabled:hover {
    background: #f0fdf8 !important;
  }
  .ca-btn-pay.p-button:disabled {
    opacity: 0.35 !important;
  }

  .ca-btn-decline.p-button {
    background: #ffffff !important;
    border: 1px solid #ef4444 !important;
    color: #dc2626 !important;
    border-radius: 8px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.7rem !important;
    font-weight: 600 !important;
    padding: 6px 12px !important;
    box-shadow: none !important;
    white-space: nowrap;
  }
  .ca-btn-decline.p-button:enabled:hover {
    background: #fef2f2 !important;
  }
  .ca-btn-decline.p-button:disabled {
    opacity: 0.35 !important;
  }

  .ca-empty {
    font-size: 0.8rem;
    color: #9ca3af;
    padding: 14px 0 4px;
    font-style: italic;
  }

  .ca-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 48px 0;
    color: #9ca3af;
    font-size: 0.82rem;
  }
  .ca-state i {
    font-size: 1.6rem;
  }
  .ca-state.ca-state-error i { color: #ef4444; }
  .ca-state .p-button {
    margin-top: 4px;
  }

  /* ── Fix universal: la "X" de cierre de cualquier Dialog debe verse siempre ── */
  .p-dialog .p-dialog-header-icon {
    color: #6b7280 !important;
    background: transparent !important;
    border-radius: 8px !important;
    width: 30px !important;
    height: 30px !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
  .p-dialog .p-dialog-header-icon:hover {
    background: #f3f4f6 !important;
    color: #374151 !important;
  }
  .p-dialog .p-dialog-header-icon .p-icon,
  .p-dialog .p-dialog-header-close-icon {
    width: 14px !important;
    height: 14px !important;
    color: inherit !important;
  }

  .p-dialog.ca-approve-dialog {
    border-radius: 16px !important;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    box-shadow: 0 20px 48px rgba(0,0,0,0.18) !important;
  }
  .p-dialog.ca-approve-dialog .p-dialog-header {
    background: #ffffff !important;
    padding: 20px 24px 14px !important;
    border-bottom: 1px solid #f1f3f5 !important;
  }
  .p-dialog.ca-approve-dialog .p-dialog-title {
    font-size: 1.02rem !important;
    font-weight: 800 !important;
    color: #1a1d23 !important;
  }
  .p-dialog.ca-approve-dialog .p-dialog-content {
    padding: 20px 24px 8px !important;
    background: #ffffff !important;
  }
  .p-dialog.ca-approve-dialog .p-dialog-footer {
    padding: 14px 24px 20px !important;
    border-top: 1px solid #f1f3f5 !important;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }

  .ca-approve-summary {
    background: #eff6ff;
    border: 1px solid #bfdbfe;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 0.78rem;
    color: #1d4ed8;
    margin-bottom: 18px;
  }
  .ca-approve-summary b { color: #1e40af; }

  .ca-approve-summary.success {
    background: #f0fdf8;
    border-color: #bbf7d0;
    color: #047857;
  }
  .ca-approve-summary.success b { color: #065f46; }

  .ca-approve-summary.danger {
    background: #fef2f2;
    border-color: #fecaca;
    color: #b91c1c;
  }
  .ca-approve-summary.danger b { color: #991b1b; }

  .ca-approve-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }
  .ca-approve-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 16px;
  }
  .ca-approve-label {
    font-size: 0.76rem;
    font-weight: 600;
    color: #374151;
  }

  .ca-approve-field .p-inputnumber-input,
  .ca-approve-field .p-inputtext,
  .ca-approve-field .p-inputtextarea,
  .ca-approve-field .p-calendar .p-inputtext {
    border-radius: 10px !important;
    border: 1px solid #e2e8f0 !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-size: 0.85rem !important;
    padding: 10px 12px !important;
    width: 100%;
    background: #ffffff !important;
    color: #1a1d23 !important;
  }
  .ca-approve-field .p-inputnumber,
  .ca-approve-field .p-calendar {
    width: 100%;
  }
  .ca-approve-field .p-inputnumber-input:focus,
  .ca-approve-field .p-inputtextarea:focus,
  .ca-approve-field .p-calendar .p-inputtext:focus {
    border-color: #00A86B !important;
    box-shadow: 0 0 0 1px #00A86B !important;
  }
  .ca-approve-field.danger .p-inputtextarea:focus {
    border-color: #ef4444 !important;
    box-shadow: 0 0 0 1px #ef4444 !important;
  }

  .ca-dialog-btn-cancel.p-button {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    color: #64748b !important;
    border-radius: 10px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.82rem !important;
    padding: 10px 20px !important;
  }

  .ca-dialog-btn-confirm.p-button {
    background: #00A86B !important;
    border: none !important;
    color: #fff !important;
    border-radius: 10px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.82rem !important;
    padding: 10px 20px !important;
    box-shadow: 0 4px 14px rgba(0,168,107,0.28) !important;
  }
  .ca-dialog-btn-confirm.p-button:enabled:hover {
    background: #009960 !important;
  }

  .ca-dialog-btn-decline-confirm.p-button {
    background: #dc2626 !important;
    border: none !important;
    color: #fff !important;
    border-radius: 10px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    font-weight: 600 !important;
    font-size: 0.82rem !important;
    padding: 10px 20px !important;
    box-shadow: 0 4px 14px rgba(220,38,38,0.28) !important;
  }
  .ca-dialog-btn-decline-confirm.p-button:enabled:hover {
    background: #b91c1c !important;
  }

  .ca-disburse-note {
    font-size: 0.85rem;
    color: #374151;
    line-height: 1.6;
    margin-top: 4px;
  }

  .p-datepicker {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    border-radius: 12px !important;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    box-shadow: 0 12px 32px rgba(0,0,0,0.12) !important;
  }
  .p-datepicker .p-datepicker-header {
    background: #ffffff !important;
    color: #1a1d23 !important;
    border-bottom: 1px solid #f1f3f5 !important;
  }
  .p-datepicker .p-datepicker-header .p-datepicker-title,
  .p-datepicker .p-datepicker-header .p-datepicker-title select {
    color: #1a1d23 !important;
  }
  .p-datepicker .p-datepicker-prev,
  .p-datepicker .p-datepicker-next {
    color: #6b7280 !important;
  }
  .p-datepicker .p-datepicker-prev:hover,
  .p-datepicker .p-datepicker-next:hover {
    color: #00A86B !important;
    background: #f0fdf8 !important;
  }
  .p-datepicker table th {
    color: #9ca3af !important;
  }
  .p-datepicker table td > span {
    color: #374151 !important;
  }
  .p-datepicker table td > span:not(.p-highlight):not(.p-disabled):hover {
    background: #f0fdf8 !important;
    color: #047857 !important;
  }
  .p-datepicker table td.p-datepicker-today > span {
    background: #eefdf6 !important;
    color: #047857 !important;
    border: 1px solid #00A86B !important;
  }
  .p-datepicker table td > span.p-highlight {
    background: #00A86B !important;
    color: #ffffff !important;
  }

  .p-datepicker .p-datepicker-header .p-datepicker-title button,
  .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month,
  .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year {
    color: #1a1d23 !important;
    background: transparent !important;
  }
  .p-datepicker .p-datepicker-header .p-datepicker-title button:hover,
  .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-month:hover,
  .p-datepicker .p-datepicker-header .p-datepicker-title .p-datepicker-year:hover {
    color: #00A86B !important;
  }

  .p-datepicker .p-monthpicker,
  .p-datepicker .p-yearpicker {
    background: #ffffff !important;
  }
  .p-datepicker .p-monthpicker .p-monthpicker-month,
  .p-datepicker .p-yearpicker .p-yearpicker-year {
    color: #374151 !important;
    border-radius: 8px !important;
  }
  .p-datepicker .p-monthpicker .p-monthpicker-month:not(.p-highlight):hover,
  .p-datepicker .p-yearpicker .p-yearpicker-year:not(.p-highlight):hover {
    background: #f0fdf8 !important;
    color: #047857 !important;
  }
  .p-datepicker .p-monthpicker .p-monthpicker-month.p-highlight,
  .p-datepicker .p-yearpicker .p-yearpicker-year.p-highlight {
    background: #00A86B !important;
    color: #ffffff !important;
  }

  .ca-approve-field .p-calendar .p-datepicker-trigger.p-button,
  .ca-approve-field .p-calendar-w-btn .p-datepicker-trigger.p-button {
    background: #ffffff !important;
    border: 1px solid #e2e8f0 !important;
    color: #00A86B !important;
    border-radius: 8px !important;
    box-shadow: none !important;
  }
  .ca-approve-field .p-calendar .p-datepicker-trigger.p-button:enabled:hover,
  .ca-approve-field .p-calendar-w-btn .p-datepicker-trigger.p-button:enabled:hover {
    background: #f0fdf8 !important;
    border-color: #00A86B !important;
    color: #047857 !important;
  }
  .ca-approve-field .p-calendar .p-datepicker-trigger.p-button:focus,
  .ca-approve-field .p-calendar-w-btn .p-datepicker-trigger.p-button:focus {
    box-shadow: 0 0 0 1px #00A86B !important;
  }

  /* ── Diálogo de información completa ── */
  .p-dialog.ca-detail-dialog {
    border-radius: 16px !important;
    overflow: hidden;
    font-family: 'Plus Jakarta Sans', sans-serif !important;
    box-shadow: 0 20px 48px rgba(0,0,0,0.18) !important;
  }
  .p-dialog.ca-detail-dialog .p-dialog-header {
    background: #ffffff !important;
    padding: 20px 24px 14px !important;
    border-bottom: 1px solid #f1f3f5 !important;
  }
  .p-dialog.ca-detail-dialog .p-dialog-title {
    font-size: 1.02rem !important;
    font-weight: 800 !important;
    color: #1a1d23 !important;
  }
  .p-dialog.ca-detail-dialog .p-dialog-content {
    padding: 20px 24px 24px !important;
    background: #ffffff !important;
  }

  .ca-detail-section {
    margin-bottom: 22px;
  }
  .ca-detail-section:last-child {
    margin-bottom: 0;
  }
  .ca-detail-section-title {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #9ca3af;
    margin-bottom: 10px;
    padding-bottom: 6px;
    border-bottom: 1px solid #f1f3f5;
  }

  .ca-detail-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px 20px;
  }
  .ca-detail-item {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }
  .ca-detail-label {
    font-size: 0.66rem;
    color: #9ca3af;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    font-weight: 600;
  }
  .ca-detail-value {
    font-size: 0.84rem;
    color: #1a1d23;
    font-weight: 600;
  }

  .ca-detail-header-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 18px;
    flex-wrap: wrap;
    gap: 10px;
  }
  .ca-detail-credit-number {
    font-size: 1.05rem;
    font-weight: 800;
    color: #1a1d23;
  }

  .ca-detail-ref-item {
    background: #f8fafc;
    border: 1px solid #f1f3f5;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 10px;
  }
  .ca-detail-ref-item:last-child {
    margin-bottom: 0;
  }
  .ca-detail-ref-name {
    font-size: 0.82rem;
    font-weight: 700;
    color: #1a1d23;
  }
  .ca-detail-ref-relationship {
    font-size: 0.7rem;
    color: #6b7280;
    margin-left: 6px;
  }
  .ca-detail-ref-contact {
    font-size: 0.74rem;
    color: #6b7280;
    margin-top: 4px;
  }

  .ca-detail-empty-refs {
    font-size: 0.8rem;
    color: #9ca3af;
    font-style: italic;
  }

  .ca-detail-loading {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 48px 0;
    color: #9ca3af;
    font-size: 0.82rem;
  }
  .ca-detail-loading i {
    font-size: 1.6rem;
  }

  .ca-detail-rejection {
    background: #fef2f2;
    border: 1px solid #fecaca;
    border-radius: 10px;
    padding: 12px 14px;
    font-size: 0.8rem;
    color: #b91c1c;
    line-height: 1.5;
  }

  /* ── Diálogo de pago de cuota ── */
  .ca-pay-summary {
    background: #f0fdf8;
    border: 1px solid #bbf7d0;
    border-radius: 10px;
    padding: 10px 14px;
    font-size: 0.78rem;
    color: #047857;
    margin-bottom: 8px;
  }
  .ca-pay-summary b { color: #065f46; }

  .ca-pay-balance-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8fafc;
    border: 1px solid #f1f3f5;
    border-radius: 10px;
    padding: 10px 14px;
    margin-bottom: 18px;
  }
  .ca-pay-balance-label {
    font-size: 0.72rem;
    color: #6b7280;
    font-weight: 600;
  }
  .ca-pay-balance-value {
    font-size: 0.92rem;
    color: #1a1d23;
    font-weight: 800;
  }

  .ca-pay-suggested-label{
    font-size: 0.92rem;
    color: #1a1d23;
  }

  @media (max-width: 640px) {
    .ca-header-count { display: none; }
    .ca-approve-grid { grid-template-columns: 1fr; }
    .ca-detail-grid { grid-template-columns: 1fr; }
  }
`;

interface ClienteInfo {
  ClientId: number;
  documentType: string;
  documentNumber: string;
  name: string;
  lastName: string;
  phone: string;
  email: string | null;
}

interface CreditoItem {
  idCredito: number;
  creditNumber: string;
  requestedAmount: string | null;
  approvedAmount: string | null;
  disbursedAmount: string | null;
  interestRate: string | null;
  termMonths: number;
  installmentValue: string | null;
  remainingBalance: string | null;
  daysOverdue: number;
  status: "pendiente" | "aprobado" | "activo" | "rechazado" | string;
  createdAt: string;
  rejectionReason?: string | null;
  cliente: ClienteInfo;
}

interface CreditTypeGroup {
  idTipoCredito: number;
  name: string;
  code: string;
  defaultInterestRate: string;
  active: boolean;
  totalCreditos: number;
  carteraTotal: number;
  creditos: CreditoItem[];
}

const currency = (value: any) => {
  if (value === null || value === undefined) return "—";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "—";
  return new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
};

const formatDate = (value: any) => {
  if (!value) return "—";
  return new Date(value).toLocaleDateString("es-CO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
};

const statusLabels: Record<string, string> = {
  pendiente: "Pendiente",
  aprobado: "Aprobado",
  activo: "Activo",
  rechazado: "Rechazado",
};

const statusTone: Record<string, "warning" | "info" | "success" | "danger"> = {
  pendiente: "warning",
  aprobado: "info",
  activo: "success",
  rechazado: "danger",
};

const getMainAmount = (credit: CreditoItem) => {
  if (credit.status === "activo") return { label: "Desembolsado", value: credit.disbursedAmount };
  if (credit.status === "aprobado") return { label: "Aprobado", value: credit.approvedAmount };
  return { label: "Solicitado", value: credit.requestedAmount };
};

function CreditsAccordion(): JSX.Element {
  const toast = useRef<Toast>(null);

  const [groups, setGroups] = useState<CreditTypeGroup[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<boolean>(false);
  const [actionLoadingId, setActionLoadingId] = useState<number | null>(null);

  const [approveVisible, setApproveVisible] = useState<boolean>(false);
  const [approveCredit, setApproveCredit] = useState<CreditoItem | null>(null);
  const [approveAmount, setApproveAmount] = useState<number | null>(null);
  const [approveRate, setApproveRate] = useState<number | null>(null);
  const [approveDate, setApproveDate] = useState<Date | null>(new Date());
  const [approving, setApproving] = useState<boolean>(false);

  const [disburseVisible, setDisburseVisible] = useState<boolean>(false);
  const [disburseCredit, setDisburseCredit] = useState<CreditoItem | null>(null);
  const [disbursing, setDisbursing] = useState<boolean>(false);

  const [detailVisible, setDetailVisible] = useState<boolean>(false);
  const [detailData, setDetailData] = useState<any | null>(null);
  const [loadingDetail, setLoadingDetail] = useState<boolean>(false);

  const [payVisible, setPayVisible] = useState<boolean>(false);
  const [payCreditItem, setPayCreditItem] = useState<CreditoItem | null>(null);
  const [payAmount, setPayAmount] = useState<number | null>(null);
  const [paying, setPaying] = useState<boolean>(false);

  // ── Estado del diálogo de rechazo ──
  const [declineVisible, setDeclineVisible] = useState<boolean>(false);
  const [declineCreditItem, setDeclineCreditItem] = useState<CreditoItem | null>(null);
  const [declineReason, setDeclineReason] = useState<string>("");
  const [declining, setDeclining] = useState<boolean>(false);

  const loadCredits = async (silent: boolean = false) => {
    if (!silent) setLoading(true);
    setError(false);
    try {
      const response: any = await getCreditsGroupedByType();
      setGroups(response?.data ?? response ?? []);
    } catch (err) {
      setError(true);
    } finally {
      if (!silent) setLoading(false);
    }
  };

  useEffect(() => {
    loadCredits();
  }, []);

  // ── Aprobación ──
  const openApproveDialog = (credit: CreditoItem, group: CreditTypeGroup) => {
    setApproveCredit(credit);
    setApproveAmount(
      credit.approvedAmount ? parseFloat(credit.approvedAmount) : parseFloat(credit.requestedAmount ?? "0")
    );
    setApproveRate(credit.interestRate ? parseFloat(credit.interestRate) : parseFloat(group.defaultInterestRate));
    setApproveDate(new Date());
    setApproveVisible(true);
  };

  const closeApproveDialog = () => {
    if (approving) return;
    setApproveVisible(false);
    setApproveCredit(null);
  };

  const confirmApprove = async () => {
    if (!approveCredit) return;

    if (approveAmount === null || approveAmount <= 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Monto inválido",
        detail: "Ingresa un monto aprobado válido",
        life: 3000,
      });
      return;
    }
    if (approveRate === null || approveRate <= 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Tasa inválida",
        detail: "Ingresa una tasa de interés válida",
        life: 3000,
      });
      return;
    }

    setApproving(true);
    setActionLoadingId(approveCredit.idCredito);
    try {
      const payload: ApproveCreditDto = {
        creditId: approveCredit.idCredito,
        clientId: approveCredit.cliente.ClientId,
        decision: "aprobado",
        montoAprobado: approveAmount,
        tasaInteres: approveRate,
        fechaAprobacion: approveDate ? approveDate.toISOString() : undefined,
      };

      await approveCreditService(payload);

      toast.current?.show({
        severity: "success",
        summary: "Crédito aprobado",
        detail: `El crédito ${approveCredit.creditNumber} fue aprobado correctamente`,
        life: 3000,
      });

      setApproveVisible(false);
      setApproveCredit(null);
      await loadCredits(true);
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo aprobar",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
    } finally {
      setApproving(false);
      setActionLoadingId(null);
    }
  };

  // ── Desembolso ──
  const openDisburseDialog = (credit: CreditoItem) => {
    setDisburseCredit(credit);
    setDisburseVisible(true);
  };

  const closeDisburseDialog = () => {
    if (disbursing) return;
    setDisburseVisible(false);
    setDisburseCredit(null);
  };

  const confirmDisburse = async () => {
    if (!disburseCredit) return;

    setDisbursing(true);
    setActionLoadingId(disburseCredit.idCredito);
    try {
      await disburseCreditService(disburseCredit.idCredito, disburseCredit.cliente.ClientId);

      toast.current?.show({
        severity: "success",
        summary: "Crédito desembolsado",
        detail: `El crédito ${disburseCredit.creditNumber} fue desembolsado correctamente`,
        life: 3000,
      });

      setDisburseVisible(false);
      setDisburseCredit(null);
      await loadCredits(true);
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo desembolsar",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
    } finally {
      setDisbursing(false);
      setActionLoadingId(null);
    }
  };

  // ── Información completa ──
  const openDetailDialog = async (credit: CreditoItem) => {
    setDetailVisible(true);
    setLoadingDetail(true);
    setDetailData(null);
    try {
      const response: any = await getFullInformationCreditService(credit.cliente.ClientId, credit.idCredito);
      setDetailData(response?.data ?? response ?? null);
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo cargar la información",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
      setDetailVisible(false);
    } finally {
      setLoadingDetail(false);
    }
  };

  const closeDetailDialog = () => {
    setDetailVisible(false);
    setDetailData(null);
  };

  // ── Pago de cuota ──
  const openPayDialog = (credit: CreditoItem) => {
    setPayCreditItem(credit);
    setPayAmount(null);
    setPayVisible(true);
  };

  const closePayDialog = () => {
    if (paying) return;
    setPayVisible(false);
    setPayCreditItem(null);
    setPayAmount(null);
  };

  const confirmPay = async () => {
    if (!payCreditItem) return;

    if (payAmount === null || payAmount <= 0) {
      toast.current?.show({
        severity: "warn",
        summary: "Monto inválido",
        detail: "Ingresa un monto a pagar válido",
        life: 3000,
      });
      return;
    }

    const remaining = parseFloat(payCreditItem.remainingBalance ?? "0");
    if (payAmount > remaining) {
      toast.current?.show({
        severity: "warn",
        summary: "Monto excede el saldo",
        detail: `El saldo pendiente es ${currency(remaining)}`,
        life: 3500,
      });
      return;
    }

    setPaying(true);
    setActionLoadingId(payCreditItem.idCredito);
    try {
      await payCredit(payCreditItem.idCredito, payCreditItem.cliente.ClientId, payAmount);

      setPayVisible(false);
      setPayCreditItem(null);
      setPayAmount(null);

      await loadCredits(true);

      toast.current?.show({
        severity: "success",
        summary: "Pago registrado",
        detail: `Se aplicó ${currency(payAmount)} al crédito ${payCreditItem.creditNumber}`,
        life: 3000,
      });
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo registrar el pago",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
    } finally {
      setPaying(false);
      setActionLoadingId(null);
    }
  };

  // ── Rechazo de crédito ──
  const openDeclineDialog = (credit: CreditoItem) => {
    setDeclineCreditItem(credit);
    setDeclineReason("");
    setDeclineVisible(true);
  };

  const closeDeclineDialog = () => {
    if (declining) return;
    setDeclineVisible(false);
    setDeclineCreditItem(null);
    setDeclineReason("");
  };

  const confirmDecline = async () => {
    if (!declineCreditItem) return;

    if (!declineReason.trim()) {
      toast.current?.show({
        severity: "warn",
        summary: "Motivo requerido",
        detail: "Ingresa el motivo del rechazo",
        life: 3000,
      });
      return;
    }

    setDeclining(true);
    setActionLoadingId(declineCreditItem.idCredito);
    try {
      const payload: ApproveCreditDto = {
        creditId: declineCreditItem.idCredito,
        clientId: declineCreditItem.cliente.ClientId,
        decision: "rechazado",
        motivoRechazo: declineReason.trim(),
      };

      await declineCredit(payload);

      setDeclineVisible(false);
      setDeclineCreditItem(null);
      setDeclineReason("");

      await loadCredits(true);

      toast.current?.show({
        severity: "success",
        summary: "Crédito rechazado",
        detail: `El crédito ${declineCreditItem.creditNumber} fue rechazado correctamente`,
        life: 3000,
      });
    } catch (err: any) {
      toast.current?.show({
        severity: "error",
        summary: "No se pudo rechazar",
        detail: err?.response?.data?.message ?? "Intenta nuevamente",
        life: 4000,
      });
    } finally {
      setDeclining(false);
      setActionLoadingId(null);
    }
  };

  // ── Columnas de la tabla ──
  const creditBody = (credit: CreditoItem) => (
    <div>
      <div className="ca-cell-title">{credit.creditNumber}</div>
      <div className="ca-cell-sub">Creado {formatDate(credit.createdAt)}</div>
    </div>
  );

  const clientBody = (credit: CreditoItem) => (
    <div>
      <div className="ca-cell-title">{credit.cliente?.name} {credit.cliente?.lastName}</div>
      <div className="ca-cell-sub">
        {credit.cliente?.documentType} {credit.cliente?.documentNumber}
      </div>
    </div>
  );

  const amountBody = (credit: CreditoItem) => {
    const { label, value } = getMainAmount(credit);
    return (
      <div>
        <div className="ca-amount-label">{label}</div>
        <div className="ca-amount-value">{currency(value)}</div>
      </div>
    );
  };

  const termBody = (credit: CreditoItem) => `${credit.termMonths} meses`;

  const rateBody = (credit: CreditoItem, group: CreditTypeGroup) =>
    `${credit.interestRate ?? group.defaultInterestRate}%`;

  const moraBody = (credit: CreditoItem) =>
    credit.daysOverdue > 0 ? <span className="ca-mora">{credit.daysOverdue} días</span> : "—";

  const statusBody = (credit: CreditoItem) => {
    const tone = statusTone[credit.status] ?? "info";
    return (
      <span
        className={`ca-pill ${tone}`}
        title={credit.status === "rechazado" ? credit.rejectionReason ?? "" : undefined}
      >
        {statusLabels[credit.status] ?? credit.status}
      </span>
    );
  };

  const actionsBody = (credit: CreditoItem, group: CreditTypeGroup) => {
    const isLoadingRow = actionLoadingId === credit.idCredito;
    return (
      <div className="ca-actions">
        <Button
          type="button"
          label="Ver información completa"
          icon="pi pi-eye"
          className="ca-btn-view"
          onClick={() => openDetailDialog(credit)}
        />
        <Button
          type="button"
          label="Aprobar crédito"
          className="ca-btn-approve"
          disabled={credit.status !== "pendiente" || isLoadingRow}
          loading={isLoadingRow && !approveVisible}
          onClick={() => openApproveDialog(credit, group)}
        />
        <Button
          type="button"
          label="Rechazar crédito"
          icon="pi pi-times-circle"
          className="ca-btn-decline"
          disabled={credit.status !== "pendiente" || isLoadingRow}
          loading={isLoadingRow && !declineVisible}
          onClick={() => openDeclineDialog(credit)}
        />
        <Button
          type="button"
          label="Desembolsar crédito"
          className="ca-btn-disburse"
          disabled={credit.status !== "aprobado" || isLoadingRow}
          loading={isLoadingRow && !disburseVisible}
          onClick={() => openDisburseDialog(credit)}
        />
        <Button
          type="button"
          label="Pagar cuota"
          icon="pi pi-money-bill"
          className="ca-btn-pay"
          disabled={credit.status !== "activo" || isLoadingRow}
          loading={isLoadingRow && !payVisible}
          onClick={() => openPayDialog(credit)}
        />
      </div>
    );
  };

  return (
    <>
      <style>{styles}</style>
      <Toast ref={toast} />

      {loading && (
        <div className="ca-state">
          <i className="pi pi-spin pi-spinner" />
          Cargando créditos...
        </div>
      )}

      {!loading && error && (
        <div className="ca-state ca-state-error">
          <i className="pi pi-exclamation-triangle" />
          No se pudieron cargar los créditos.
          <Button label="Reintentar" icon="pi pi-refresh" onClick={() => loadCredits()} className="p-button-text" />
        </div>
      )}

      {!loading && !error && (!groups || groups.length === 0) && (
        <div className="ca-empty">Aún no hay créditos registrados.</div>
      )}

      {!loading && !error && groups && groups.length > 0 && (
        <div className="ca-root">
          <Accordion multiple activeIndex={[0]}>
            {groups.map((grupo) => (
              <AccordionTab
                key={grupo.idTipoCredito}
                header={
                  <div className="ca-header">
                    <div className="ca-header-left">
                      <div className="ca-header-icon">
                        <i className="pi pi-wallet" />
                      </div>
                      <div>
                        <div className="ca-header-title">{grupo.name}</div>
                        <div className="ca-header-sub">Código: {grupo.code}</div>
                      </div>
                    </div>
                    <span className="ca-header-count">
                      {grupo.totalCreditos} {grupo.totalCreditos === 1 ? "crédito" : "créditos"}
                    </span>
                  </div>
                }
              >
                <DataTable
                  value={grupo.creditos}
                  className="ca-table"
                  scrollable
                  scrollHeight="420px"
                  size="small"
                  emptyMessage="No hay créditos en este tipo"
                >
                  <Column header="Crédito" body={creditBody} style={{ minWidth: "140px" }} />
                  <Column header="Cliente" body={clientBody} style={{ minWidth: "160px" }} />
                  <Column header="Monto" body={amountBody} style={{ minWidth: "140px" }} />
                  <Column header="Plazo" body={termBody} style={{ minWidth: "90px" }} />
                  <Column header="Tasa" body={(row) => rateBody(row, grupo)} style={{ minWidth: "80px" }} />
                  <Column header="Mora" body={moraBody} style={{ minWidth: "90px" }} />
                  <Column header="Estado" body={statusBody} style={{ minWidth: "110px" }} />
                  <Column header="Acciones" body={(row) => actionsBody(row, grupo)} style={{ minWidth: "580px" }} />
                </DataTable>
              </AccordionTab>
            ))}
          </Accordion>
        </div>
      )}

      {/* ── Diálogo de aprobación ── */}
      <Dialog
        header="Aprobar crédito"
        visible={approveVisible}
        onHide={closeApproveDialog}
        className="ca-approve-dialog"
        style={{ width: "520px", maxWidth: "95vw" }}
        modal
        footer={
          <>
            <Button
              type="button"
              label="Cancelar"
              className="ca-dialog-btn-cancel"
              onClick={closeApproveDialog}
              disabled={approving}
            />
            <Button
              type="button"
              label={approving ? "Aprobando..." : "Confirmar aprobación"}
              className="ca-dialog-btn-confirm"
              onClick={confirmApprove}
              disabled={approving}
            />
          </>
        }
      >
        {approveCredit && (
          <>
            <div className="ca-approve-summary">
              Crédito <b>{approveCredit.creditNumber}</b> — {approveCredit.cliente?.name} {approveCredit.cliente?.lastName}
              {" "}({approveCredit.cliente?.documentType} {approveCredit.cliente?.documentNumber})
            </div>

            <div className="ca-approve-grid">
              <div className="ca-approve-field">
                <label className="ca-approve-label">Monto aprobado</label>
                <InputNumber
                  value={approveAmount}
                  onValueChange={(e) => setApproveAmount(e.value ?? null)}
                  mode="currency"
                  currency="COP"
                  locale="es-CO"
                  maxFractionDigits={0}
                />
              </div>

              <div className="ca-approve-field">
                <label className="ca-approve-label">Tasa de interés (%)</label>
                <InputNumber
                  value={approveRate}
                  onValueChange={(e) => setApproveRate(e.value ?? null)}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  suffix="%"
                />
              </div>
            </div>

            <div className="ca-approve-field">
              <label className="ca-approve-label">Fecha de aprobación</label>
              <Calendar
                value={approveDate}
                onChange={(e) => setApproveDate(e.value as Date)}
                dateFormat="dd/mm/yy"
                showIcon
                maxDate={new Date()}
              />
            </div>
          </>
        )}
      </Dialog>

      {/* ── Diálogo de rechazo ── */}
      <Dialog
        header="Rechazar crédito"
        visible={declineVisible}
        onHide={closeDeclineDialog}
        className="ca-approve-dialog"
        style={{ width: "480px", maxWidth: "95vw" }}
        modal
        footer={
          <>
            <Button
              type="button"
              label="Cancelar"
              className="ca-dialog-btn-cancel"
              onClick={closeDeclineDialog}
              disabled={declining}
            />
            <Button
              type="button"
              label={declining ? "Rechazando..." : "Confirmar rechazo"}
              className="ca-dialog-btn-decline-confirm"
              onClick={confirmDecline}
              disabled={declining}
            />
          </>
        }
      >
        {declineCreditItem && (
          <>
            <div className="ca-approve-summary danger">
              Crédito <b>{declineCreditItem.creditNumber}</b> — {declineCreditItem.cliente?.name} {declineCreditItem.cliente?.lastName}
              {" "}({declineCreditItem.cliente?.documentType} {declineCreditItem.cliente?.documentNumber})
            </div>

            <div className="ca-approve-field danger">
              <label className="ca-approve-label">Motivo del rechazo<span style={{ color: "#ef4444", marginLeft: 4 }}>*</span></label>
              <InputTextarea
                value={declineReason}
                onChange={(e) => setDeclineReason(e.target.value)}
                rows={4}
                autoResize
                placeholder="Explica por qué se rechaza este crédito..."
              />
            </div>
          </>
        )}
      </Dialog>

      {/* ── Diálogo de desembolso ── */}
      <Dialog
        header="Confirmar desembolso"
        visible={disburseVisible}
        onHide={closeDisburseDialog}
        className="ca-approve-dialog"
        style={{ width: "460px", maxWidth: "95vw" }}
        modal
        footer={
          <>
            <Button
              type="button"
              label="Cancelar"
              className="ca-dialog-btn-cancel"
              onClick={closeDisburseDialog}
              disabled={disbursing}
            />
            <Button
              type="button"
              label={disbursing ? "Desembolsando..." : "Confirmar desembolso"}
              className="ca-btn-disburse"
              onClick={confirmDisburse}
              disabled={disbursing}
            />
          </>
        }
      >
        {disburseCredit && (
          <>
            <div className="ca-approve-summary success">
              Crédito <b>{disburseCredit.creditNumber}</b> — {disburseCredit.cliente?.name} {disburseCredit.cliente?.lastName}
              {" "}({disburseCredit.cliente?.documentType} {disburseCredit.cliente?.documentNumber})
            </div>
            <p className="ca-disburse-note">
              Vas a desembolsar <b>{currency(disburseCredit.approvedAmount)}</b> a este cliente.
              Esta acción activará el crédito y no se puede deshacer.
            </p>
          </>
        )}
      </Dialog>

      {/* ── Diálogo de información completa ── */}
      <Dialog
        header="Información completa del crédito"
        visible={detailVisible}
        onHide={closeDetailDialog}
        className="ca-detail-dialog"
        style={{ width: "680px", maxWidth: "95vw" }}
        modal
      >
        {loadingDetail && (
          <div className="ca-detail-loading">
            <i className="pi pi-spin pi-spinner" />
            Cargando información...
          </div>
        )}

        {!loadingDetail && detailData && (
          <>
            <div className="ca-detail-header-row">
              <span className="ca-detail-credit-number">{detailData.creditNumber}</span>
              <span className={`ca-pill ${statusTone[detailData.status] ?? "info"}`}>
                {statusLabels[detailData.status] ?? detailData.status}
              </span>
            </div>

            {detailData.status === "rechazado" && detailData.rejectionReason && (
              <div className="ca-detail-section">
                <div className="ca-detail-rejection">
                  <i className="pi pi-info-circle" style={{ marginRight: 6 }} />
                  {detailData.rejectionReason}
                </div>
              </div>
            )}

            <div className="ca-detail-section">
              <div className="ca-detail-section-title">Tipo de crédito</div>
              <div className="ca-detail-grid">
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Nombre</span>
                  <span className="ca-detail-value">{detailData.tipoCredito?.name}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Código</span>
                  <span className="ca-detail-value">{detailData.tipoCredito?.code}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Tasa por defecto</span>
                  <span className="ca-detail-value">{detailData.tipoCredito?.defaultInterestRate}%</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Requiere codeudor</span>
                  <span className="ca-detail-value">{detailData.tipoCredito?.requiresCosigner ? "Sí" : "No"}</span>
                </div>
              </div>
            </div>

            <div className="ca-detail-section">
              <div className="ca-detail-section-title">Condiciones del crédito</div>
              <div className="ca-detail-grid">
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Monto solicitado</span>
                  <span className="ca-detail-value">{currency(detailData.requestedAmount)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Monto aprobado</span>
                  <span className="ca-detail-value">{currency(detailData.approvedAmount)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Monto desembolsado</span>
                  <span className="ca-detail-value">{currency(detailData.disbursedAmount)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Saldo capital</span>
                  <span className="ca-detail-value">{currency(detailData.remainingBalance)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Plazo</span>
                  <span className="ca-detail-value">{detailData.termMonths} meses</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Tasa de interés</span>
                  <span className="ca-detail-value">{detailData.interestRate ? `${detailData.interestRate}%` : "—"}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Valor cuota</span>
                  <span className="ca-detail-value">{currency(detailData.installmentValue)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Días en mora</span>
                  <span className="ca-detail-value">{detailData.daysOverdue}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Fecha de aprobación</span>
                  <span className="ca-detail-value">{formatDate(detailData.approvalDate)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Fecha de desembolso</span>
                  <span className="ca-detail-value">{formatDate(detailData.disbursementDate)}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Cuotas Pagadas</span>
                  <span className="ca-detail-value">{detailData.paidInstallments}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Creado</span>
                  <span className="ca-detail-value">{formatDate(detailData.createdAt)}</span>
                </div>
              </div>
            </div>

            <div className="ca-detail-section">
              <div className="ca-detail-section-title">Cliente</div>
              <div className="ca-detail-grid">
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Nombre completo</span>
                  <span className="ca-detail-value">{detailData.cliente?.name} {detailData.cliente?.lastName}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Documento</span>
                  <span className="ca-detail-value">{detailData.cliente?.documentType} {detailData.cliente?.documentNumber}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Teléfono</span>
                  <span className="ca-detail-value">{detailData.cliente?.phone}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Correo</span>
                  <span className="ca-detail-value">{detailData.cliente?.email}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Dirección</span>
                  <span className="ca-detail-value">{detailData.cliente?.address}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Ciudad / Región</span>
                  <span className="ca-detail-value">{detailData.cliente?.city}, {detailData.cliente?.region}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Ocupación</span>
                  <span className="ca-detail-value">{detailData.cliente?.occupation}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Empresa</span>
                  <span className="ca-detail-value">{detailData.cliente?.employer}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Tipo de contrato</span>
                  <span className="ca-detail-value">{detailData.cliente?.contractType}</span>
                </div>
                <div className="ca-detail-item">
                  <span className="ca-detail-label">Ingresos mensuales</span>
                  <span className="ca-detail-value">{currency(detailData.cliente?.monthlyIncome)}</span>
                </div>
              </div>
            </div>

            <div className="ca-detail-section">
              <div className="ca-detail-section-title">Referencias personales</div>
              {(!detailData.referenciasPersonales || detailData.referenciasPersonales.length === 0) && (
                <div className="ca-detail-empty-refs">No hay referencias registradas</div>
              )}
              {detailData.referenciasPersonales?.map((ref: any) => (
                <div className="ca-detail-ref-item" key={ref.idReferencia}>
                  <span className="ca-detail-ref-name">{ref.name} {ref.lastName}</span>
                  <span className="ca-detail-ref-relationship">({ref.relationship})</span>
                  <div className="ca-detail-ref-contact">
                    {ref.phone} {ref.email && `· ${ref.email}`}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
      </Dialog>

      {/* ── Diálogo de pago de cuota ── */}
      <Dialog
        header="Registrar pago"
        visible={payVisible}
        onHide={closePayDialog}
        className="ca-approve-dialog"
        style={{ width: "460px", maxWidth: "95vw" }}
        modal
        footer={
          <>
            <Button
              type="button"
              label="Cancelar"
              className="ca-dialog-btn-cancel"
              onClick={closePayDialog}
              disabled={paying}
            />
            <Button
              type="button"
              label={paying ? "Registrando..." : "Confirmar pago"}
              className="ca-dialog-btn-confirm"
              onClick={confirmPay}
              disabled={paying}
            />
          </>
        }
      >
        {payCreditItem && (
          <>
            <div className="ca-pay-summary">
              Crédito <b>{payCreditItem.creditNumber}</b> — {payCreditItem.cliente?.name} {payCreditItem.cliente?.lastName}
            </div>

            <div className="ca-pay-balance-row">
              <span className="ca-pay-balance-label">Saldo pendiente</span>
              <span className="ca-pay-balance-value">{currency(payCreditItem.remainingBalance)}</span>
            </div>

            <div className="ca-pay-suggested-label">
                Cuota sugerida: {currency(payCreditItem.installmentValue)}
            </div>

            <div className="ca-approve-field">
              <label className="ca-approve-label">Valor a pagar</label>
              <InputNumber
                value={payAmount}
                onValueChange={(e) => setPayAmount(e.value ?? null)}
                mode="currency"
                currency="COP"
                locale="es-CO"
                maxFractionDigits={0}
                min={0}
                autoFocus
              />
            </div>
          </>
        )}
      </Dialog>
    </>
  );
}

export default CreditsAccordion;